import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusBadge = ({ 
  status, 
  size = 'default', 
  clickable = false, 
  onClick = null,
  installation = null 
}) => {
  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'planned':
        return {
          label: 'Planned',
          icon: 'Calendar',
          className: 'bg-blue-100 text-blue-800 border-blue-200',
          hoverClassName: 'hover:bg-blue-200',
          action: 'Mark Installed'
        };
      case 'installed':
        return {
          label: 'Installed',
          icon: 'CheckCircle',
          className: 'text-[#7BA428] border-[#A3D977]',
          bgClassName: 'bg-[#A3D977]/20',
          hoverClassName: 'hover:bg-[#A3D977]/30',
          action: 'Mark Verified',
          requiresImage: true
        };
      case 'verified':
        return {
          label: 'Verified',
          icon: 'Shield',
          className: 'bg-[#28A745]/20 text-[#28A745] border-[#28A745]',
          hoverClassName: '', // Non-clickable for verified
          nonEditable: true
        };
      default:
        return {
          label: 'Unknown',
          icon: 'HelpCircle',
          className: 'bg-gray-100 text-gray-800 border-gray-200'
        };
    }
  };

  const config = getStatusConfig(status);
  const sizeClasses = size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-1.5 text-sm';
  const iconSize = size === 'sm' ? 12 : 14;
  
  const isClickable = clickable && onClick && !config?.nonEditable;
  const isDisabled = config?.requiresImage && installation?.photos?.length === 0;
  
  const baseClasses = `inline-flex items-center gap-1.5 font-medium rounded-full border ${sizeClasses}`;
  const stateClasses = isClickable 
    ? `cursor-pointer transition-all duration-200 ${config?.hoverClassName || ''} ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}` 
    : '';
  
  const fullClassName = `${baseClasses} ${config?.bgClassName || ''} ${config?.className} ${stateClasses}`?.trim();

  const handleClick = () => {
    if (!isClickable || isDisabled) return;
    
    // Special validation for installed → verified transition
    if (status?.toLowerCase() === 'installed' && config?.requiresImage) {
      if (!installation?.photos || installation?.photos?.length === 0) {
        alert('Please upload at least one image before marking as verified.');
        return;
      }
    }
    
    onClick();
  };

  if (isClickable) {
    return (
      <button
        className={fullClassName}
        onClick={handleClick}
        title={isDisabled ? 'Upload image first' : config?.action}
        disabled={isDisabled}
      >
        <Icon name={config?.icon} size={iconSize} />
        {config?.label}
        {config?.nonEditable && <Icon name="Lock" size={10} className="ml-1" />}
      </button>
    );
  }

  return (
    <span className={fullClassName}>
      <Icon name={config?.icon} size={iconSize} />
      {config?.label}
      {status?.toLowerCase() === 'verified' && <Icon name="ShieldCheck" size={10} className="ml-1" />}
    </span>
  );
};

export default StatusBadge;